/**
 * Cart guard: if a parent (device) with _requires_fragrance is in cart without its child fragrance, remove parent and alert.
 * @version v1.0
 */
var EE_MANDATORY_FRAGRANCE_CART_VERSION = 'v1.0';
(function () {
  const message = typeof window.eeMandatoryFragranceCartMessage === 'string'
    ? window.eeMandatoryFragranceCartMessage
    : 'This device requires a fragrance to be purchased.';

  let debounceTimer;

  function validateCart(cart) {
    if (!cart || !cart.items || !cart.items.length) return;
    const parentVariantIds = new Set();
    cart.items.forEach((item) => {
      const p = item.properties || {};
      if (p._requires_fragrance) {
        parentVariantIds.add(String(item.variant_id));
      }
    });
    const childForVariantIds = new Set();
    cart.items.forEach((item) => {
      const p = item.properties || {};
      const forId = p._mandatory_for_variant_id;
      if (forId) childForVariantIds.add(String(forId));
    });
    const orphanParentKeys = [];
    parentVariantIds.forEach((variantId) => {
      if (!childForVariantIds.has(variantId)) {
        const line = cart.items.find((i) => String(i.variant_id) === variantId);
        if (line) orphanParentKeys.push(line.key);
      }
    });
    return orphanParentKeys;
  }

  async function runGuard() {
    try {
      const root = window.Shopify?.routes?.root || '/';
      const cart = await fetch(root + 'cart.js').then((r) => r.json());
      const keysToRemove = validateCart(cart);
      if (!keysToRemove || keysToRemove.length === 0) return;
      for (const key of keysToRemove) {
        await fetch(root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: key, quantity: 0 })
        });
      }
      document.dispatchEvent(new CustomEvent('toast:show', { detail: { message, tone: 'error' } }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    } catch (e) {
      console.error('ee-mandatory-fragrance cart guard:', e);
    }
  }

  function debouncedGuard() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(runGuard, 300);
  }

  document.addEventListener('cart:change', debouncedGuard);
  document.addEventListener('cart:refresh', debouncedGuard);

  if (window.themeVariables?.settings?.pageType === 'cart') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', runGuard);
    } else {
      runGuard();
    }
  }
})();
